import { ref, set } from 'firebase/database';
import { SessionWithId } from '../../Models/session';
import { database } from '../firebase';
import { getSession } from './GetSession';
import { getSignedInPersonId } from './GetSignedInPersonId';

export const logIntoSession: (session: SessionWithId) => Promise<void> = async (
    session,
) => {
    const userHash = getSignedInPersonId();

    let currentSession = await getSession(session);

    if (!currentSession) {
        throw Error('The session does not exist');
    }

    if (
        currentSession.session.people &&
        Object.keys(currentSession.session.people).length >=
            currentSession.session.capacity
    ) {
        throw Error('The session is full');
    }

    try {
        await set(
            ref(database, `sessions/${currentSession.id}/people/${userHash}`),
            true,
        );
    } catch (error) {
        throw error;
    }

    return;
};
